<template>
  <q-dialog
    v-model="dialog"
    persistent
    maximized
    class="custom-font text-uppercase"
    transition-show="slide-up"
    transition-hide="slide-down"
  >
    <view-file />
    <detalle-item-solicitud :modalidad_id="solicitud.modalidad_id" />
    <historial-solicitud />
    <observar-solicitud />
    <rechazar-solicitud />
    <aprobar-solicitud />
    <autorizar-solicitud />
    <q-card
      style="width: 100%; height: 100%"
      flat v-if="loading"
      class="flex flex-center pragma-black glossy"
    >
      <q-card-section class="absolute-bottom text-center items-center">
        <div class="row full-width">
          <div class="col-xs-12">
            <q-btn
              icon="clear"
              flat
              class="text-pragma"
              size="lg"
              @click="closeDialog()"
            ></q-btn>
          </div>
        </div>
      </q-card-section>
      <q-card-section class="text-center">
        <div>
          <q-spinner-bars
            class="text-pragma"
            size="4em"
          />
          <q-tooltip :offset="[0, 8]">QSpinnerBars</q-tooltip>
        </div>
      </q-card-section>
    </q-card>
    <q-card
      style="width: 100%"
      v-if="!loading"
      class="pragma-black"
    >
      <q-card-section class="text-center text-white">
        <div class="row">
          <div class="col-xs-2">
            <q-btn round color="white" icon="arrow_back" class="bg-pragma" @click="closeDialog()" />
          </div>
          <div class="col-xs-8">
            <span class="text-h6 text-bold">Detalles</span>
          </div>
          <div class="col-xs-2">
            <!-- Controller Buttons -->
            <q-btn round color="white" icon="list" class="bg-pragma">
              <q-menu dark class="bg-pragma-secon custom-font">

                <!-- Opciones para solicitudes para todas  -->
                <div class="q-pa-none">
                  <q-list style="min-width: 150px" separator dark dense>
                    <q-item clickable v-close-popup @click="aprobarRendicionSolicitud({solicitud})">
                      <q-item-section>Aprobar Rendición</q-item-section>
                    </q-item>
                    <q-item clickable v-close-popup @click="observarSolicitud(solicitud.id)">
                      <q-item-section>Observar</q-item-section>
                    </q-item>
                    <q-item clickable v-close-popup @click="rechazarSolicitud(solicitud.id)">
                      <q-item-section>Rechazar</q-item-section>
                    </q-item>
                    <q-item clickable v-close-popup @click="verHistorialSolicitud()">
                      <q-item-section>Historial</q-item-section>
                    </q-item>
                    <q-item clickable v-close-popup @click="verRendicion(solicitud)" v-if="solicitud.items_rendidos.length > 0 && solicitud.last_estado_id > 50">
                      <q-item-section>Ver rendición</q-item-section>
                    </q-item>
                    <q-item clickable v-close-popup @click="imprimirDocumentos(solicitud)" v-if="solicitud.items_rendidos.length > 0 && solicitud.last_estado_id > 50">
                      <q-item-section>Documentos rendición</q-item-section>
                    </q-item>
                  </q-list>
                </div>

              </q-menu>
            </q-btn>
          </div>
        </div>
      </q-card-section>
      <q-separator></q-separator>
      <q-card-section>
        <div class="row q-gutter-y-sm">
          <div class="col-xs-4 text-white q-pr-xs">
            <q-card flat class="bg-pragma">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Nro. sol.
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.numero}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-4 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Estado
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{util.getLastState(solicitud.historial.estados)}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-4 text-white q-pl-xs">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Fecha limite
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{vmoment(solicitud.fecha_limite).format('DD/MM/YYYY')}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Empresa
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.empresa}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Proyecto
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.proyecto}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Solicitante
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.usuario}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-pragma">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Modalidad
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.modalidad}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12">
            <div class="row">
              <div :class="solicitud.tipo_cambio !== 1 ? 'col-xs-6 q-pr-xs' : 'col-xs-12'">
                <q-card flat class="bg-grey-9 text-white">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Moneda
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{solicitud.moneda}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-6 q-pl-xs" v-if="solicitud.tipo_cambio !== 1">
                <q-card flat class="bg-grey-9 text-white">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Tipo de cambio
                  </q-card-section>
                  <q-card-section class="q-pa-xs text-right">
                    {{solicitud.tipo_cambio}}
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </div>
        </div>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <q-card-section v-if="solicitud.documentos.length > 0" class="q-pa-none">
        <div class="row q-py-sm text-white bg-grey-10">
          <div class="col-xs-12 q-px-xs">
            <q-list>
              <q-expansion-item
                dense
                expand-separator
                label="Documentos adjuntos"
                class="text-bold"
                dark
              >
                <q-list>
                  <q-item
                    clickable
                    v-ripple
                    v-for="documento in solicitud.documentos"
                    :key="documento.id"
                    @click="verDocumento(documento)"
                  >
                    <q-card style="width: 100%" class="text-caption">
                      <q-card-section class="bg-grey-9 text-white">
                        <div class="row full-width">
                          <div class="col-xs-2">
                            <q-icon name="attach_file" size="sm"></q-icon>
                          </div>
                          <div class="col-xs-10 wrap">
                            <span style="word-break: break-all">{{documento.direccion}}</span>
                          </div>
                        </div>
                      </q-card-section>
                    </q-card>
                  </q-item>
                </q-list>
              </q-expansion-item>
            </q-list>
          </div>
        </div>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <!-- Items antiguos -->
      <q-card-section class="text-center text-white"  v-if="solicitud.items_antiguos.length > 0">
        <strong>ITEMS ANTIGUOS</strong>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <q-card-section class="q-pa-none bg-pragma" v-if="solicitud.items_antiguos.length > 0">
        <div class="row q-py-sm text-white bg-grey-10">
          <div class="col-xs-12 q-px-xs">
            <q-list>
              <q-expansion-item
                dense
                expand-separator
                label="ítem de la solicitud original"
                class="text-bold"
                dark
              >
                <q-list separator bordered v-if="solicitud.modalidad_id == 1 || solicitud.modalidad_id == 2" class="q-px-md">
                  <q-item
                    clickable
                    v-ripple
                    v-for="(item, index) in solicitud.items_antiguos"
                    :key="item.id"
                    @click="verDetalleItem(item)"
                    :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                  >
                    <q-item-section>
                      <q-item-label class="text-white">{{item.detalle}}</q-item-label>
                      <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                      <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                      <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
                <q-list separator bordered v-if="solicitud.modalidad_id == 3 || solicitud.modalidad_id == 4" class="q-px-md">
                  <q-item
                    clickable
                    v-ripple
                    v-for="(item, index) in solicitud.items_antiguos"
                    :key="item.id"
                    @click="verDetalleItem(item)"
                    :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                  >
                    <q-item-section>
                      <q-item-label>{{item.detalle}}</q-item-label>
                      <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                      <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                      <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-expansion-item>
            </q-list>
          </div>
        </div>
      </q-card-section>
      <q-separator class="bg-pragma"  v-if="solicitud.items_antiguos.length > 0"></q-separator>
      <q-card-section v-if="solicitud.items_antiguos.length > 0" class="bg-pragma">
        <div class="row">
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Desembolso antiguo
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.desembolso_antiguo}}
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <!-- Items de la solicitud -->
      <q-card-section class="text-center text-white">
        <strong>ITEMS DE LA SOLICITUD</strong>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <q-card-section>
        <div class="row">
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Desembolso
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.desembolso}}
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <q-card-section class="q-pa-none">
        <div class="row q-py-sm text-white bg-grey-10">
          <div class="col-xs-12 q-px-xs">
            <q-list>
              <q-expansion-item
                dense
                expand-separator
                label="ítem de la solicitud"
                class="text-bold"
                dark
              >
                <q-list separator bordered v-if="solicitud.modalidad_id == 1 || solicitud.modalidad_id == 2" class="q-px-md">
                  <q-item
                    clickable
                    v-ripple
                    v-for="(item, index) in solicitud.items"
                    :key="item.id"
                    @click="verDetalleItem(item)"
                    :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                  >
                    <q-item-section>
                      <q-item-label class="text-white">{{item.detalle}}</q-item-label>
                      <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                      <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                      <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
                <q-list separator bordered v-if="solicitud.modalidad_id == 3 || solicitud.modalidad_id == 4" class="q-px-md">
                  <q-item
                    clickable
                    v-ripple
                    v-for="(item, index) in solicitud.items_rendidos"
                    :key="item.id"
                    @click="verDetalleItem(item)"
                    :class="index%2 == 0 ? 'bg-grey-8' : 'bg-grey-9'"
                  >
                    <q-item-section>
                      <q-item-label>{{item.detalle}}</q-item-label>
                      <q-item-label caption class="text-white">Cant.: {{~~item.cantidad}}</q-item-label>
                    </q-item-section>

                    <q-item-section side top>
                      <q-badge color="blue-grey" :label="`P/U: ${item.costo}`" />
                      <q-item-label class="text-right text-caption q-pt-lg text-bold text-white">Subtotal: {{util.numberMoney(item.subtotal)}}</q-item-label>
                    </q-item-section>
                  </q-item>
                </q-list>
              </q-expansion-item>
            </q-list>
          </div>
        </div>
      </q-card-section>
      <q-separator class="bg-pragma"></q-separator>
      <q-card-section>
        <div class="row q-gutter-y-sm">
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-pragma">
              <q-card-section class="q-pa-xs">
                <div class="row">
                  <div class="col-xs-4 text-bold text-caption">
                    Total:
                  </div>
                  <div class="col-xs-8 text-right">
                    {{util.numberMoney(solicitud.total)}}
                  </div>
                </div>
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Son
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{ literalMount(solicitud.total, solicitud.moneda) }}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Referencia
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.referencia}}
              </q-card-section>
            </q-card>
          </div>
          <div class="col-xs-12 text-white">
            <q-card flat class="bg-grey-9">
              <q-card-section class="text-caption q-pa-xs text-bold">
                Justificación
              </q-card-section>
              <q-card-section class="q-pa-xs">
                {{solicitud.observacion}}
              </q-card-section>
            </q-card>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </q-dialog>
</template>

<script>
import axios from 'axios'
import {inject, ref} from 'vue'
import moment from 'moment'

import env from '../../../../../config/env'
import NumeroALetras from '../../../../plugins/literal-count'
import util from '../../../../plugins/util'
import ViewFile from '../../../../components/ViewFile.vue'
import DetalleItemSolicitud from '../../../solicitud/dialogs/DetalleItemSolicitud.vue'
import HistorialSolicitud from '../../../solicitud/dialogs/HistorialSolicitud.vue'
import ObservarSolicitud from './ObservarSolicitud.vue'
import RechazarSolicitud from './RechazarSolicitud.vue'
import AprobarSolicitud from './AprobarRendicionSolicitud.vue'
import AutorizarSolicitud from './AutorizarSolicitud.vue'
import { useQuasar } from 'quasar'

export default {
  components: {
    ViewFile,
    DetalleItemSolicitud,
    HistorialSolicitud,
    ObservarSolicitud,
    RechazarSolicitud,
    AprobarSolicitud,
    AutorizarSolicitud
  },
  setup () {
    // Variables reactivas y no reactivas
    const $q = useQuasar()
    const bus = inject('bus')

    const dialog = ref(false)
    const solicitud = ref({})
    const items_modificados = ref([])
    const loading = ref(false)
    const pending_loading = ref({
      pendiente1: false,
      pendiente2: false,
      pendiente3: false,
      pendiente4: false,
      pendiente5: false,
      pendiente6: false,
      pendiente7: false,
      pendiente8: false,
      pendiente9: false,
      pendiente10: false,
      pendiente11: false,
      pendiente12: false,
    })
    
    const vmoment = moment
    const literalMount = NumeroALetras
    const current_page = ref(null)

    // Métodos y funciones
    const closeDialog = () => {
      solicitud.value = {}
      dialog.value = false
      loading.value = false
    }

    const getDatosSolicitud = async (solicitud_id) => {
      try {
        loading.value = true
        let res = await axios.get(`json/datos_solicitud/${solicitud_id}`)
        solicitud.value = res.data
        res = await axios.get(`json/items_solicitud/${solicitud_id}`)
        solicitud.value.items = res.data
        res = await axios.get(`json/items_rendidos/${solicitud_id}`)
        solicitud.value.items_rendidos = res.data
        res = await axios.get(`solicitudes/estados/${solicitud_id}`)
        solicitud.value.historial = res.data
        res = await axios.get(`json/documentos_solicitud/${solicitud_id}`)
        solicitud.value.documentos = res.data
        res = await axios.get(`json/documentos_rendicion/${solicitud_id}`)
        solicitud.value.documentos_rendicion = res.data
        res = await axios.get(`json/items_antiguos_solicitud/${solicitud_id}`)
        solicitud.value.items_antiguos = res.data
        loading.value = false
      } catch (error) {
        console.log(error)
      }
    }

    const verDocumento = (documento) => {
      let url_file = `${env.SERVER_URL}empresas/${documento.empresa_slug}/${documento.gestion}/solicitud/${documento.direccion}`
      bus.emit('openDialogViewFile', url_file)
    }

    const verDetalleItem = (item) => {
      bus.emit('openDialogDetalleItemSolicitud', item)
    }

    const verHistorialSolicitud = () => {
      bus.emit('openDialogHistorialSolicitud', solicitud.value.historial)
    }

    const modificarSolicitud = (item) => {
      bus.emit('openDialogModificarSolicitud', item.solicitud)
    }

    const revisarSolicitud = (item) => {
      bus.emit('openDialogRevisarSolicitud', item)
    }

    const autorizarSolicitud = (item) => {
      bus.emit('openDialogAutorizarSolicitud', item)
    }

    const observarSolicitud = (solicitud_id) => {
      bus.emit('openDialogObservarSolicitud', solicitud_id)
    }

    const rechazarSolicitud = (solicitud_id) => {
      bus.emit('openDialogRechazarSolicitud', solicitud_id)
    }

    const aprobarRendicionSolicitud = (solicitud) => {
      bus.emit('openDialogAprobarRendicionSolicitud', solicitud)
    }

    const verRendicion = async (solicitud) => {
      window.open(`${env.SERVER_URL}api/v1/solicitud-imprimir/rendicion?id_sol=${solicitud.id}`)
    }

    const imprimirDocumentos = async (solicitud) => {
      window.open(`${env.API_URL}solicitud-documentos/rendicion/generar/${solicitud.id}`)
    }

    const pendienteSolicitud = async (nro_pend, solicitud_id) => {
      try {
        switch (nro_pend) {
          case '':
            pending_loading.value.pendiente1 = true
            break
          case '2':
            pending_loading.value.pendiente2 = true
            break
          case '3':
            pending_loading.value.pendiente3 = true
            break
          case '4':
            pending_loading.value.pendiente4 = true
            break
          case '5':
            pending_loading.value.pendiente5 = true
            break
          case '6':
            pending_loading.value.pendiente6 = true
            break
          case '7':
            pending_loading.value.pendiente7 = true
            break
          case '8':
            pending_loading.value.pendiente8 = true
            break
          case '9':
            pending_loading.value.pendiente9 = true
            break
          case '10':
            pending_loading.value.pendiente10 = true
            break
          case '11':
            pending_loading.value.pendiente11 = true
            break
          case '12':
            pending_loading.value.pendiente12 = true
            break
        }
        await axios.get(`solicitudes-admin/cambio/pendiente${nro_pend}?pendiente=${solicitud_id}&platform=${util.getPlatform()}`)
        closeDialog()
        bus.emit('closeDialogCrearSolicitudAutorizar')
        $q.notify({
          message: nro_pend == '' ? `Solicitud a pendientes 1` : `Solicitud a pendientes ${nro_pend}`,
          color: 'positive'
        })
        pending_loading.value ={
          pendiente1: false,
          pendiente2: false,
          pendiente3: false,
          pendiente4: false,
          pendiente5: false,
          pendiente6: false,
          pendiente7: false,
          pendiente8: false,
          pendiente9: false,
          pendiente10: false,
          pendiente11: false,
          pendiente12: false,
        }
      } catch (error) {
        console.log(error)
        pending_loading.value ={
          pendiente1: false,
          pendiente2: false,
          pendiente3: false,
          pendiente4: false,
          pendiente5: false,
          pendiente6: false,
          pendiente7: false,
          pendiente8: false,
          pendiente9: false,
          pendiente10: false,
          pendiente11: false,
          pendiente12: false,
        }
      }
    }

    // Creación del componente
    bus.on('openDialogDetalleSolicitudAutorizar', (item) => {
      current_page.value = item.current_page
      getDatosSolicitud(item.id)
      dialog.value = true
    })
    bus.on('closeDialogModificarSolicitud', () => {
      bus.emit('closeDialogCrearSolicitudAutorizar')
      dialog.value = false
    })
    bus.on('closeDialogEventoAutorizar', () => {
      closeDialog()
      bus.emit('closeDialogCrearSolicitudAutorizar')
    })

    // Retorno de variables template
    return {
      dialog,
      closeDialog,
      solicitud,
      vmoment,
      literalMount,
      items_modificados,
      loading,
      verDocumento,
      verDetalleItem,
      verHistorialSolicitud,
      modificarSolicitud,
      util,
      current_page,
      revisarSolicitud,
      observarSolicitud,
      rechazarSolicitud,
      pendienteSolicitud,
      pending_loading,
      aprobarRendicionSolicitud,
      autorizarSolicitud,
      verRendicion,
      imprimirDocumentos
    }
  }
}
</script>

<style>

</style>